import { withServerSideCatalogue } from "lib/hoc/withServerSideCatalogue";
import { Dashboard } from "screens/Dashboard";
import { withCatalogueServerSideProps } from "lib/serverSideProps/withCatalogue";
import { withUserServerSideProps } from "lib/serverSideProps/withUser";
import { withServerSideProps } from "lib/serverSideProps/withServerSideProps";
import { withWebLayout } from "lib/hoc/withWebLayout";
import { withHOC } from "lib/hoc/withHOC";

export const getServerSideProps = withServerSideProps([
  withCatalogueServerSideProps,
  withUserServerSideProps,
]);

export default withHOC([withServerSideCatalogue, withWebLayout], Dashboard);
